import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  StyledRadioCenter,
  StyledRadioContainer,
} from '../SelectReportType/styles'
import {
  StyledConfirmButton,
  StyledCancelButton,
} from '../../CountdownTimer/styles'
import {
  StyledWrapper,
  StyledTitle,
  StyledSelectTypeWrapper,
  StyledTypeWrapper,
  StyledTextWrapper,
  StyledRadioTitle,
  StyledWarning,
  StyledMetricInfo,
  StyledButtonsWrapper,
} from './styles'

const typeMessages = ['All conversions', 'Paid', 'Unpaid']
const errorMessages = [
  `Warning! All conversions for all metrics will be deleted from this campaign,
   both paid & unpaid. If you later upload some conversions again, some BAs may be double paid.`,
  `Warning! All Paid conversions will be deleted. If you later upload some conversions again,
   some BAs may be double paid.`,
  `All Unpaid conversions will be deleted.`,
]

const DeleteConversions = ({
  totalCount,
  paidCount,
  primaryMetric,
  otherMetrics,
  onConfirm,
  onCancel,
}) => {
  const [selectedType, setSelectedType] = useState(-1)

  const handleConfirm = () => {
    if (selectedType !== -1 && onConfirm) {
      onConfirm(selectedType)
    }
  }

  const handleSelectType = type => {
    if (!type && !totalCount) return
    if (type === 1 && !paidCount) return
    if (type === 2 && totalCount === paidCount) return
    setSelectedType(type)
  }

  const selectTypeRadio = type => (
    <StyledTypeWrapper
      isSelected={type === selectedType}
      onClick={() => handleSelectType(type)}
    >
      <StyledRadioContainer>
        <StyledRadioCenter />
      </StyledRadioContainer>
      <StyledTextWrapper>
        <StyledRadioTitle>{typeMessages[type]}</StyledRadioTitle>
        {type === selectedType && (
          <StyledWarning>{errorMessages[type]}</StyledWarning>
        )}
      </StyledTextWrapper>
    </StyledTypeWrapper>
  )

  const selectTypes = () => (
    <StyledSelectTypeWrapper>
      {[0, 1, 2].map(type => selectTypeRadio(type))}
    </StyledSelectTypeWrapper>
  )

  const metricsInfo = () => (
    <StyledMetricInfo>
      Primary metric: {primaryMetric ? primaryMetric : 'No primary metric'}
      <br />
      Other metrics:{' '}
      {otherMetrics.length
        ? otherMetrics.reduce((acc, metric, index) => {
            acc += (index ? ', ' : '') + metric
            return acc
          }, '')
        : 'No other metrics'}
    </StyledMetricInfo>
  )

  return (
    <StyledWrapper>
      <StyledTitle>
        What type of conversions do you want to delete? <br />
        Paid, unpaid or all of them?
      </StyledTitle>
      {selectTypes()}
      {metricsInfo()}
      <StyledButtonsWrapper>
        <StyledCancelButton onClick={onCancel}>Cancel</StyledCancelButton>
        <StyledConfirmButton
          isReached={selectedType !== -1}
          onClick={handleConfirm}
        >
          Confirm
        </StyledConfirmButton>
      </StyledButtonsWrapper>
    </StyledWrapper>
  )
}

DeleteConversions.propTypes = {
  totalCount: PropTypes.number,
  paidCount: PropTypes.number,
  primaryMetric: PropTypes.string,
  otherMetrics: PropTypes.array,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default DeleteConversions
